// @flow

/**
 * Module dependencies.
 */

import { LinkIcon } from 'client/components/core/buttons/links';
import { branch, translator } from 'core/utils';
import { colors } from 'client/styles';
import { get } from 'lodash';
import Icon from 'client/components/core/icon';
import React from 'react';
import config from 'config';
import i18n from 'client/translations/i18n';

/**
 * `Props` type.
 */

type Props = {
  fixed: boolean,
  translate: Function
};

/**
 * `Link` component.
 */

const Link = LinkIcon.withComponent('a');

/**
 * `LoginButton` component.
 */

function LoginButton(props: Props): ?React$Element<*> {
  const { fixed, translate } = props;
  const { rollingStone, white } = colors;
  const loginUrl = get(config, 'loginUrl');
  const localisedLoginUrl = `${loginUrl}?locale=${i18n.language}`;

  return branch(loginUrl, () => (
    <Link
      color={fixed ? rollingStone : white}
      href={localisedLoginUrl}
      rel={'noopener'}
    >
      <Icon icon={'login'} />

      {translate('login')}
    </Link>
  ));
}

/**
 * Export `LoginButton`.
 */

export default translator()(LoginButton);



// WEBPACK FOOTER //
// ../src/client/components/navbar/login-button.js